import { func } from '../../helpers';
import { SET_SET_SETTINGS } from '../_types';

const ci = [
    { value: 'ci_momo', label: 'Mobile Money (Interne)' },
    { value: 'ci_card', label: 'Carte banquaire (Interne)' },
    { value: 'ci_foreign', label: `Carte banquaire (Extérieur)` },
];

const initialState = {

    kyc: func.getStorageJson('kyc') || {},
    fees: func.getStorageJson('fees') || {},
    forex: func.getStorageJson('forex') || [],
    social: func.getStorageJson('social') || {},
    settings: func.getStorageJson('settings') || {},
    countries: func.getStorageJson('countries') || [],

    navigation: [
        { name: 'Home', link: '' },
        // { name: 'Pricing', link: 'pricing' },
        // {name: 'About us', link: 'about'},
        { name: 'Ticketing', link: 'tickets' },
        { name: 'Contact us', link: 'contact' },
        { name: 'Terms & Conditions', link: 'terms-conditions' },
        { name: 'Privacy Policy', link: 'privacy-policy' },
    ],
    paymentMethods: {
        gh: [
            { value: 'gh_momo', label: 'Mobile Money (Ghana only)' },
            { value: 'gh_card', label: 'Visa / MasterCard (Ghana only)' },
            // { value: 'gh_crypto', label: 'Crypto (USDT)' },
            { value: 'gh_foreign', label: 'Visa / MasterCard (Outside Ghana)' },
        ],
        ng: [
            { value: 'ng_bank', label: 'Bank Transfer (Nigeria only)' },
            { value: 'ng_card', label: 'Visa / MasterCard (Nigeria only)' },
            { value: 'ng_foreign', label: 'Visa / MasterCard (Outside Nigeria)' },
        ],
        ci, bj: ci, cd: ci, cm: ci, ml: ci, sn: ci, tg: ci, bf: ci,
    },
};

const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;

        case SET_SET_SETTINGS:
            return {
                ...state,
                [action.key]: action.value,
            };
    }
};


export default dataReducer;